<ng-content select="[pageHeader]"></ng-content>
<div class="lib-page-layout-content">
  <ng-content></ng-content>
</div>
<ng-content select="[pageActions]"></ng-content>
<ng-content select="[pageFooter]"></ng-content>
